/**
 * Navigation state passed via React Router location.state when navigating
 * to child pages (detail, form, document viewer). Used for "Torna indietro"
 * to return to the actual previous screen when available.
 */
export interface NavigationState {
    /** Previous pathname + search (e.g. /shipper/containers?view=map) */
    from?: string;
}

const INTERNAL_PREFIXES = [
    '/shipper',
    '/receiver',
    '/admin',
    '/freight-forwarder',
    '/auth',
] as const;

/**
 * Returns true if `from` is a non-empty string and an internal app path
 * (starts with one of the app route prefixes). Used to avoid using
 * external or invalid URLs as back target.
 */
export function isInternalFrom(from: unknown): from is string {
    if (typeof from !== 'string' || from.length === 0) return false;
    const path = from.startsWith('?') ? from : from.split('?')[0];
    return INTERNAL_PREFIXES.some((prefix) => path === prefix || path.startsWith(prefix + '/'));
}

/** Location-like shape (pathname + search) for building state */
export interface LocationLike {
    pathname: string;
    search?: string;
}

/**
 * Builds state object to pass when navigating to a child page so the
 * child can use "Torna indietro" to return here.
 * Usage: navigate(to, { state: navigationStateFrom(location) })
 */
export function navigationStateFrom(loc: LocationLike): NavigationState {
    const from = loc.search ? `${loc.pathname}${loc.search}` : loc.pathname;
    return { from };
}
